import React, { PropTypes } from 'react'
import Panel from 'react-bootstrap/lib/Panel'

const PaymentSchemesDefault = ({ onPSForm }) => (
  <Panel header="PaymentSchemes">
    <h4>Manage Payment Scheme Fees</h4>
    <hr />
    <button type="button" onClick={onPSForm} className="btn btn-info">Add New Payment Scheme</button>
  </Panel>
)

PaymentSchemesDefault.propTypes = {
  onPSForm: PropTypes.func,
}

export default PaymentSchemesDefault



// WEBPACK FOOTER //
// ./src/containers/Manage/PaymentSchemes/default.js